$(function () {
  var host = "https://dip.sylvoxtv.com/api/api";
  
  const quantityList = ["1-5 units", "6-10 units", "More than 10 units"];
  const sizeList = ["43″", "55″", "65″", "75″", "86″", "110″", "Other"];
  const typeList = ["Partial Sun Outdoor TV", "Full Sun Outdoor TV", "Commercial Displays", "Kitchen TV", "Bathroom TV", "12V RV TV", "Portable TV"];
  const payList = ["Online Payment", "Invoice / Bank Transfer"];

  //渲染复选框组 (Multi-select: Quantity, Size, Type)
  function renderCheckboxGroup(list, containerId, hiddenInputId, groupName) {
    const $container = $('#' + containerId);
    $container.empty();
    $container.addClass('checkbox-container');
    list.forEach(function(item) {
        const html = `
          <label class="checkbox-label-item">
              <input type="checkbox" name="${groupName}" value="${item}">
              <span>${item}</span>
          </label>
        `;
        $container.append(html);
    });
    $container.find('input[type="checkbox"]').on('change', function() {
        const $parentLabel = $(this).closest('.checkbox-label-item');
        
        if ($(this).is(':checked')) {
            $parentLabel.addClass('is-active');
        } else {
            $parentLabel.removeClass('is-active');
        }

        // 更新数据到 hidden input
        updateCheckboxValue(containerId, hiddenInputId);
    });
  }

  //渲染单选框组 (Single-select: Pay)
  function renderRadioGroup(list, containerId, hiddenInputId, groupName) {
    const $container = $('#' + containerId);
    $container.empty();
    $container.addClass('radio-container');
    
    list.forEach(function(item) {
        const html = `
          <label class="radio-label-item">
              <input type="radio" name="${groupName}" value="${item}">
              <span>${item}</span>
          </label>
        `;
        $container.append(html);
    });
    $container.find('input[type="radio"]').on('change', function() {
        const val = $(this).val();
        const $labels = $container.find('.radio-label-item');
        
        // 清除所有选中样式，给当前选中的添加样式
        $labels.removeClass('is-active');
        $(this).closest('.radio-label-item').addClass('is-active');

        // 单选直接赋值，不需要逗号拼接
        $(hiddenInputId).val(val).removeClass('error-input');
    });
  }

  //复选框数据收集容器内所有选中的值并拼接
  function updateCheckboxValue(containerId, hiddenInputId) {
      const $container = $('#' + containerId);
      const $checkedInputs = $container.find('input[type="checkbox"]:checked');
      let values = [];
      let isOtherSelected = false;

      $checkedInputs.each(function() {
          const val = $(this).val();
          if (val === 'Other') {
              isOtherSelected = true;
          } else {
              values.push(val);
          }
      });

      // 特殊处理 Size 组的 Other 逻辑
      if (containerId === 'sizeBox') {
          handleSizeOther(isOtherSelected, values, hiddenInputId);
      } else {
          $(hiddenInputId).val(values.join(', ')).removeClass('error-input');
      }
  }

  // Size组的 Other 特殊处理
  function handleSizeOther(isSelected, currentValues, hiddenInputId) {
      const $otherWrap = $('#sizeOtherInputWrap');
      const $otherInput = $('#sizeOtherInput');
      if (isSelected) {
          $otherWrap.slideDown(200);
          const otherText = $otherInput.val().trim();
          if (otherText) {
              currentValues.push(otherText); 
          }
      } else {
          $otherWrap.slideUp(200);
          $otherInput.removeClass('error-input');
      }
      $(hiddenInputId).val(currentValues.join(', ')).removeClass('error-input');
  }

  // 监听 Other 输入框
  $('#sizeOtherInput').on('input', function() {
      updateCheckboxValue('sizeBox', '#formSizeSelect');
      $(this).removeClass('error-input');
  });

  // Quantity, Size, Type 使用复选框逻辑
  renderCheckboxGroup(quantityList, "quantityBox", "#formQuantitySelect", "quantityGroup");
  renderCheckboxGroup(sizeList, "sizeBox", "#formSizeSelect", "sizeGroup");
  renderCheckboxGroup(typeList, "typeBox", "#formTypeSelect", "typeGroup");
  
  // Pay 使用单选框逻辑
  renderRadioGroup(payList, "payBox", "#formPaySelect", "payGroup");

  $("#buyInBulkForm").on('click',function () {
        $('#buyingInBulkForm').show();
        $('.form-success-contair').hide();
        $('.site-header__element--top').hide();
         $("#myModal").fadeIn(150);
         disableScroll();
  });
  
  $("#email, #userName, #cellPhone").on("change", function () {
    $(this).removeClass("error-input");
  });

  var submitBoolen = false;
  
  $("#submitBtn").on("click", function () {
    if (submitBoolen) return showToast("Requesting...");
    var hasError = false;
    var requiredFields = [
      { input: "#formQuantitySelect", container: '#quantityBox' },
      { input: "#formSizeSelect", container: '#sizeBox' },
      { input: "#formTypeSelect", container: '#typeBox' },
      { input: "#formPaySelect", container: '#payBox' }, 
      { input: "#email", isText: true },
      { input: "#userName", isText: true },
      { input: "#cellPhone", isText: true },
    ];

    requiredFields.forEach(function (f) {
      var $input = $(f.input);
      var val = $input.val();
      // Check Other Size
      if (f.input === "#formSizeSelect") {
          const isOtherChecked = $('#sizeBox').find('input[value="Other"]').is(':checked');
          const otherText = $('#sizeOtherInput').val().trim();
          
          if (isOtherChecked && !otherText) {
             $('#sizeOtherInput').addClass("error-input");
             hasError = true;
             return; 
          }
      }

      if (!val) {
        if (!f.isText) {
           $(f.container).addClass('error-input'); 
           setTimeout(() => { $(f.container).removeClass('error-input'); }, 3000);
        } else {
          $input.addClass("error-input");
        }
        hasError = true;
      }
    });

    if (hasError) {
      showToast("Incomplete required fields");
      return;
    }

    submitForm();
  });

  function submitForm() {
    var formData = new FormData();
    formData.append("number", $("#formQuantitySelect").val());
    formData.append("productSize", $("#formSizeSelect").val());
    formData.append("email", $("#email").val());
    formData.append("productType", $("#formTypeSelect").val());
    formData.append("payType", $("#formPaySelect").val());
    formData.append("name", $("#userName").val());
    formData.append("phone", $("#cellPhone").val());
    formData.append("state", $("#state").val());
    formData.append("zipCode", $("#zipCode").val());
    formData.append("remark", $("#remark").val());
    formData.append("shopType", 'Product Page Buy in Bulk Form');
    formData.append("shopName", 'eu');
    $("#submitBtn").prop("disabled", true).html("Submitting...");
    showFullscreenLoading();
    
    submitBoolen = true;

    $.ajax({
      url: host + "/addShopifyOrders",
      method: "POST",
      processData: false,
      contentType: false,
      data: formData,
      success: function (res) {
        if (res.Code == 0) {
          showToast("Submission Successful");
          $('#buyingInBulkForm').hide();
          $('.form-success-contair').show()
        } else {
          showToast(res.Msg);
        }
      },
      error: function (xhr) {
        showToast("Submit failed");
      },
      complete: function () {
        $("#submitBtn").prop("disabled", false).html("Submit");
        hideFullscreenLoading();
        submitBoolen = false;
      },
    });
  }

  $("#modalClose").on("click", function () {
    $("#myModal").fadeOut(150);
    $('.site-header__element--top').show()
    enableScroll();
    resetForm();
  });

  $("#remark").on("input", function () {
    var len = $(this).val().length;
    $("#descCounter").text(len + "/2000");
  });

  function resetForm() {
    $('#formQuantitySelect, #formSizeSelect, #formTypeSelect, #formPaySelect').val('');
    $('#userName, #email, #cellPhone, #remark, #sizeOtherInput').val('');
    
    $('input[type="checkbox"], input[type="radio"]').prop('checked', false);
    $('.checkbox-label-item, .radio-label-item').removeClass('is-active');
    
    $('#sizeOtherInputWrap').hide();
    $('.error-input').removeClass('error-input');
  }

  function showToast(msg, duration) {
    duration = duration || 2000;
    var $toast = $("#globalToast");
    $toast.text(msg).addClass("show");
    clearTimeout($toast.data("timer"));
    var timer = setTimeout(function () {
      $toast.removeClass("show");
    }, duration);
    $toast.data("timer", timer);
  }

  function showFullscreenLoading() {
    $(".loader-content").find("#loader-text").css("display", "none");
    if($(".loader-content .loader-text").length === 0) {
        $(".loader-content").append('<p class="loader-text" style="margin:0;">We will contact you as soon as possible after receiving your information...</p>');
    }
    if(window.PageLoader) PageLoader.show();
  }

  function hideFullscreenLoading() {
    $(".loader-content").find("#loader-text").css("display", "block");
    $(".loader-content .loader-text").remove();
    if(window.PageLoader) PageLoader.hide();
  }

  let scrollPosition = 0;
  function disableScroll() {
      scrollPosition = $(window).scrollTop();
      $('body').css({
          'overflow': 'hidden',
          'position': 'fixed',
          'top': -scrollPosition + 'px',
          'width': '100%'
      });
  }

  function enableScroll() {
      $('body').css({
          'overflow': '',
          'position': '',
          'top': '',
          'width': ''
      });
      $(window).scrollTop(scrollPosition);
  }

  $(window).resize(function() {
      if ($('body').css('overflow') === 'hidden') {
          $('body').css('top', -$(window).scrollTop() + 'px');
      }
  });
});